import { render, staticRenderFns } from "./SectionList.vue?vue&type=template&id=79e92846&scoped=true&"
import script from "./SectionList.vue?vue&type=script&lang=ts&"
export * from "./SectionList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e92846",
  null
  
)

export default component.exports